module.exports = __webpack_public_path__ + "assets/images/marker-shadow.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/marker-shadow.png
// module id = 1518
// module chunks = 1